import { extendVariants, Skeleton as HeroSkeleton, SkeletonProps } from '@heroui/react';

import { HeroBaseProps } from '../utils';

export const Skeleton = extendVariants(
  (props: HeroBaseProps<SkeletonProps, 'isLoaded'>) => <HeroSkeleton classNames={props.classNames} {...props} />,
  {
    variants: {
      isLoaded: {
        false: {
          base: 'bg-secondary-200 rounded-2xl before:content-[""] after:content-[""] before:via-secondary-300 after:bg-secondary-200',
        },
        true: {
          base: 'overflow-visible',
        },
      },
    },
  },
);
